import Slide from "@mui/material/Slide";

import { TransitionProps } from "./types";

const TransitionLeft = (props: TransitionProps) => {
    return <Slide {...props} direction="left" />;
};

export default TransitionLeft;
